import { InAppBrowser } from '@capgo/inappbrowser';
/* jshint esversion: 6 */
export default {
    // [TODO][CAPACITOR] chequear esta función
    openInMap (trip, isDestination, inGoogleMaps) {
        let position = trip.lat + ',' + trip.lng;
        if (isDestination) {
            position = trip.dest_lat + ',' + trip.dest_lng;
        }
        let url = 'https://www.waze.com/ul?ll=' + position + '&navigate=yes&zoom=16';
        if (inGoogleMaps) {
            url = 'https://www.google.com/maps/dir/?api=1&destination=' + position + '&travelmode=driving&dir_action=navigate';
        }
        console.log('openInMap', isDestination, inGoogleMaps, url);
        if (window.cordova) {
            return InAppBrowser.open({
                url: url
            });
        } else {
            window.open(url);
        }
    }
};

export async function openExternalLink (url) {
    if (process.env.CORDOVA) {
        await InAppBrowser.open({
            url: url
        });
    } else {
        window.open(url, '_blank');
    }
}



// WEBPACK FOOTER //
// ./src/cordova/InAppBrowser.js